import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SecurityService } from '../security.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { CustomerProfile } from '../models/customer-profile.model';
import { DataService } from 'src/app/shared/data.service';



@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  pageTitle: string = "Forgot Password";
  email: string="";
  buttonSelected: string="Login";
  prof = new CustomerProfile();
  popMsg = {
    'title':'',
    'message':''
  }



  constructor(
    public dataSvc: DataService,
    private securitySvc: SecurityService, 
    private router: Router, 
    public dialog:MatDialog, 
    public route: ActivatedRoute) { }

  ngOnInit(): void {
    let data = this.dataSvc.getSharedData();
    if(data.pageTitle != null){
      this.pageTitle = data.pageTitle;
    }
  }

  sendCodeForVerification(){
      this.prof.loginId = this.email;
      console.log(this.prof.loginId);
      this.securitySvc.resendEmailVerificationCode(this.prof).subscribe(
        res => {
          this.router.navigate(['/reset-password',{'loginId': this.prof.loginId}]);
        },
        err => {
          this.popMsg.title="Error sending verification code";
          this.popMsg.message="Please try again"
          console.log(err)
          this.openDialog(this.popMsg);
          return;
  
        })
  

  }

  openDialog(popupMessage){
    //this.dialog.open(DialogWithCloseButtonComponent, {data: {title: 'Incomplete Form', message: 'Please enter firstname'}});
    this.dialog.open(DialogWithCloseButtonComponent, {data: popupMessage});
  } 



}
